import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import moment from "moment";
import { CollapseSection } from "../CollapseSection.js";
export const LabeledOpeningHoursValue = ({ label, value, initiallyExpanded = true, notSetText, closedText, }) => {
    return (_jsx(CollapseSection, { title: label, isInitiallyExpanded: initiallyExpanded, children: !value || value.length === 0 || !value.some(v => v?.isOpen) ? (_jsx(Typography, { color: "gray", children: notSetText })) : (Array(7)
            .fill(null)
            .map((v, index) => {
            const isoDayIndex = moment().weekday(index).isoWeekday() - 1;
            const isOpen = value[isoDayIndex]?.isOpen &&
                value[isoDayIndex]?.from &&
                value[isoDayIndex]?.to;
            return (_jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", spacing: 1, children: [_jsx(Typography, { children: moment().weekday(index).format("dddd") }), _jsx(Typography, { color: !isOpen ? "gray" : undefined, children: !isOpen
                            ? closedText
                            : `${value[isoDayIndex]?.from}–${value[isoDayIndex]?.to}` })] }, index));
        })) }));
};
//# sourceMappingURL=LabeledOpeningHoursValue.js.map